export default {
  ID: 'ESIGN_CONFIRM_STEP',
  SIDEBAR_MENU: true,
  PROGRESS_BAR: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
  BUTTON_SIGN: false,
  BUTTON_CONTINUE: false,
  FOOTER_DIVIDER: false,
};
